import { getFarcasterFollowerPosts } from "@/lib/api/discover"
import { DataSource } from "./base"
import { DataSourcePagination } from "../types"
import { TrendingEntry } from "@/types/farcaster"

/**
 * Creates the Farcaster Followers datasource.
 *
 * Fetches all posts from users that someone follows on Farcaster.
 */
export default class FarcasterFollowersDataSource implements DataSource {
  constructor(private walletAddress?: string) {}

  async fetchMore(props?: DataSourcePagination) {
    if (!this.walletAddress) return null
    const fcFollowers = await getFarcasterFollowerPosts(
      props?.page || 1,
      this.walletAddress
    )
    const updatedPagination = this.updatePagination({
      currentPagination: props,
      newData: fcFollowers,
    })

    return { data: fcFollowers, pagination: updatedPagination }
  }

  getInitialPagination() {
    return { page: 1 }
  }

  updatePagination(props?: {
    currentPagination?: DataSourcePagination
    newData: TrendingEntry[]
  }) {
    const oldPage = props?.currentPagination?.page || 1
    return { page: oldPage + 1 }
  }
}
